export type MembershipPlanKey = 'friends' | 'zoroastrians' | 'supporters';

export type MembershipPlanDefinition = {
  key: MembershipPlanKey;
  name: string;
  price: number;
  description: string;
  features: string[];
};

export const MEMBERSHIP_PLAN_DEFINITIONS: MembershipPlanDefinition[] = [
  {
    key: 'zoroastrians',
    name: 'Zoroastrians',
    price: 0,
    description: 'For Zoroastrians who have had their religious status approved',
    features: ['Create groups & events', 'Browse pictures and videos', 'Messaging with other Zoroastrians', 'Community access'],
  },
  {
    key: 'supporters',
    name: 'Polgozārs',
    price: 9.99,
    description: 'Full support for active community leaders and organizers.',
    features: ['Everything in the site', 'Family tree'],
  },
];

export type ResolvedMembershipPlan = MembershipPlanDefinition & {
  id: string | null;
};

export function resolveMembershipPlans(
  apiPlans: Array<{ id?: string | null; attributes?: { name?: string | null; price?: number | null; description?: string | null } | null }>,
): ResolvedMembershipPlan[] {
  return MEMBERSHIP_PLAN_DEFINITIONS.map((def) => {
    const match = apiPlans.find((p) => {
      const name = (p.attributes?.name ?? '').toLowerCase();
      return name === def.name.toLowerCase() || name.includes(def.key);
    });
    return {
      ...def,
      id: match?.id ?? null,
      price: match?.attributes?.price ?? def.price,
      description: match?.attributes?.description ?? def.description,
    };
  });
}

export function matchPlanKey(planName?: string | null): MembershipPlanKey | null {
  if (!planName) return null;
  const n = planName.toLowerCase();
  if (n.includes('supporter')) return 'supporters';
  if (n.includes('zoroastrian')) return 'zoroastrians';
  if (n.includes('friend')) return 'friends';
  return null;
}
